// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.btn-perspective-icon {*/\n/*    width: 24px;*/\n/*    height: 24px;*/\n/*}*/\n/*.btn-scale-icon {*/\n/*    width: 26px;*/\n/*    height: 26px;*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
